<template>
	<div :class="$style['tab-wrapper']">
		<FormSection :title="$t('common.fields.company-details')">
			<BaseTextField
				v-model="companyName"
				v-validate="'required'"
				:disabled="disabled"
				:helper-text="errors.first('company-name')"
				:invalid="errors.has('company-name')"
				name="company-name"
				type="text"
				:label-text="$t('common.fields.title')"
			/>
			<InputGroup>
				<BaseTextField
					v-model="companyCode"
					v-validate="'required'"
					:disabled="disabled"
					:helper-text="errors.first('company-code')"
					:invalid="errors.has('company-code')"
					:multiple="true"
					name="company-code"
					type="text"
					:label-text="$t('clients-view.inner.company-details.fields.company-code')"
				/>
				<BaseTextField
					v-model="companyVatCode"
					:disabled="disabled"
					:helper-text="errors.first('pvm-code')"
					:invalid="errors.has('pvm-code')"
					:multiple="true"
					name="pvm-code"
					type="text"
					:label-text="`${$t('clients-view.inner.company-details.fields.vat-code')}`"
				/>
			</InputGroup>
		</FormSection>
		<FormSection :title="$t('common.fields.company-address-information')">
			<AutoCompleteField
				v-model="companyAddress"
				v-validate="'required'"
				:disabled="disabled"
				:helper-text="errors.first('address') ? errors.first('address') : ''"
				:invalid="errors.has('address')"
				name="address"
				type="text"
				:label-text="$t('clients-view.inner.company-details.fields.registration-address')"
				@place-changed="handlePlaceChange"
			/>
			<BaseDropdownInput
				v-model="companyCountry"
				v-validate:companyCountry="'required'"
				:disabled="disabled"
				:list="countries"
				:helper-text="errors.first('company-country')"
				:invalid="errors.has('company-country')"
				name="company-country"
				:label-text="$t('common.fields.country')"
			/>
			<InputGroup>
				<BaseTextField
					v-model="companyPostalCode"
					v-validate="'required'"
					:disabled="disabled"
					:helper-text="errors.first('postal-code')"
					:invalid="errors.has('postal-code')"
					:multiple="true"
					name="postal-code"
					type="text"
					:label-text="`${$t('clients-view.inner.company-details.fields.postal-code')}`"
				/>
				<AutoCompleteField
					v-model="companyCity"
					v-validate="'required'"
					:disabled="disabled"
					:helper-text="errors.first('city')"
					:invalid="errors.has('city')"
					:label-text="$t('common.fields.city')"
					name="city"
					multiple="true"
					types="(regions)"
					:country="companyCountry.id || null"
				/>
			</InputGroup>
		</FormSection>
		<!-- <BaseTextField
      v-model="companyAddress"
      v-validate="'required'"
      :helper-text="errors.first('companyAddress') ? errors.first('companyAddress') : $t('common.messages.address-caption')"
      :invalid="errors.has('companyAddress')"
      name="companyAddress"
      type="text"
      :label-text="$t('clients-view.inner.company-details.fields.registration-address')"
    /> -->

		<!-- <BaseTextField
      v-model="companyEmail"
      name="email"
      type="email"
      :label-text="$t('common.fields.email')"
    />
    <PhoneNumberField
      ref="phoneNumber"
      v-model="companyPhoneNumber"
      :default-country="companyCountry?.id || defaultCountry"
      :label-text="$t('common.fields.phone')"
      :helper-text="errors.first('phoneNumber')"
      :invalid="errors.has('phoneNumber')"
      @valid="errors.remove('phoneNumber')"
    /> -->
	</div>
</template>

<script>

import { mapMutations, mapGetters } from '@/store/modules/Clients/helpers'
import { mapActions as mapBillingActions } from '@/store/modules/Billing/helpers'
import { VALIDATE_VAT_NUMBER } from '@/store/modules/Billing/action-types'
import { UPDATE_CLIENT_FORM } from '@/store/modules/Clients/mutation-types'
import AutoCompleteField from '@/components/Essentials/AutoCompleteField'
import FormSection from '@/components/Essentials/FormSection'
import { validateVatNumberField } from '@/utils/vatValidation'
import { getCityFromPlace, getCountryComponentFromPlace } from '@/utils/address'
// import PhoneNumberField from '@/components/Essentials/PhoneNumberField'

export default {
	name: 'ClientInfo',
	components: {
		AutoCompleteField,
		FormSection
		// PhoneNumberField
	},
	props: {
		countries: {
			type: Array,
			default: () => []
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			companyCountry: {
				name: null,
				id: null
			},
			localCompanyName: null,
			localCompanyCode: null,
			localCompanyVatCode: null,
			localCompanyCity: null,
			localCompanyPostalCode: null,
			localCompanyAddress: null
		}
	},
	computed: {
		...mapGetters({
			editClientForm: 'editClientForm'
		}),


		defaultCountry () {
			if (this.$i18n.locale === 'en') {
				return 'gb'
			}
			return this.$i18n.locale
		},

		companyName: {
			get () {
				return this.localCompanyName
			},
			set (val) {
				this.localCompanyName = val
			}
		},
		companyCode: {
			get () {
				return this.localCompanyCode
			},
			set (val) {
				this.localCompanyCode = val
			}
		},
		companyVatCode: {
			get () {
				return this.localCompanyVatCode
			},
			set (val) {
				this.localCompanyVatCode = val
			}
		},
		companyCity: {
			get () {
				return this.localCompanyCity
			},
			set (val) {
				this.localCompanyCity = val
			}
		},
		companyPostalCode: {
			get () {
				return this.localCompanyPostalCode
			},
			set (val) {
				this.localCompanyPostalCode = val
			}
		},
		companyAddress: {
			get () {
				return this.localCompanyAddress
			},
			set (val) {
				this.localCompanyAddress = val
			}
		},
		companyPhoneNumber: {
			get () {
				return this.editClientForm.companyPhoneNumber
			},
			set (val) {
				this.updateClientForm({ companyPhoneNumber: val })
			}
		},
		companyEmail: {
			get () {
				return this.editClientForm.companyEmail
			},
			set (val) {
				this.updateClientForm({ companyEmail: val })
			}
		}
	},

	watch: {
		'companyCountry.id': {
			handler (val) {
				this.updateClientForm({ companyCountry: val })
			}
		}
	},

	async created () {
		const name = this.editClientForm.companyName ? this.editClientForm.companyName : this.editClientForm.name ? this.editClientForm.name : null
		this.localCompanyName = name
		this.localCompanyCode = this.editClientForm.companyCode
		this.localCompanyVatCode = this.editClientForm.companyVatCode
		this.localCompanyCity = this.editClientForm.companyCity || this.editClientForm.city || this.editClientForm.deliveryCity || null
		this.localCompanyPostalCode = this.editClientForm.companyPostalCode || this.editClientForm.postalCode || this.editClientForm.deliveryPostalCode || null
		this.localCompanyAddress = this.editClientForm.companyAddress || this.editClientForm.address || this.editClientForm.deliveryAddress || null

		const country = this.editClientForm.companyCountry ? this.editClientForm.companyCountry : this.editClientForm.deliveryCountry ? this.editClientForm.deliveryCountry : this.editClientForm.country ? this.editClientForm.country : 'LT'

		this.companyCountry = this.countries.find(_country => country && country.toLowerCase() === _country.id.toLowerCase()) || {
			name: null,
			id: null
		}

		const city = this.editClientForm.companyCity ?  this.editClientForm.companyCity : this.editClientForm.deliveryCity ? this.editClientForm.deliveryCity : null
		this.updateClientForm({ companyCity: city })
	},
	methods: {
		...mapMutations({
			updateClientForm: UPDATE_CLIENT_FORM
		}),
		...mapBillingActions({
			validateVatNumberAction: VALIDATE_VAT_NUMBER
		}),
		async validate (locked = false) {
			this.updateClientForm({
				companyName: this.localCompanyName,
				companyCode: this.localCompanyCode,
				companyVatCode: this.localCompanyVatCode,
				companyCity: this.localCompanyCity,
				companyPostalCode: this.localCompanyPostalCode,
				companyAddress: this.localCompanyAddress
			})
			if (locked) {
				return true
			}

			// if (this.companyPhoneNumber && this.companyPhoneNumber.length !== 0) {
			// 	if (!this.$refs.phoneNumber.isValid()) {
			// 	   this.errors.add({ field: 'phoneNumber', msg: this.$t('orders-view.inner.delivery-info.delivery-info-modal.errors.incorrect-phone-number') })
			// 	   this.$emit('shake')
			// 	   return false
			//    } else {
			// 		this.errors.remove('phoneNumber')
			// 	}
			// }
			this.$validator.resume()
			const valid = await this.$validator.validateAll()
			if (valid) {
				const isValidVat = await validateVatNumberField({
					validateVatNumber: this.validateVatNumberAction,
					vatNumber: this.localCompanyVatCode,
					countryCode: this.companyCountry.id,
					errors: this.errors,
					fieldName: 'pvm-code'
				})
				if (!isValidVat) {
					this.$emit('shake')
					return false
				}
				return true
			} else {
				this.$emit('shake')
				return false
			}
		},
		handlePlaceChange ({ placeResultData }) {
			const country = getCountryComponentFromPlace(placeResultData)
			const city = getCityFromPlace(placeResultData)
			const postalCode = placeResultData.address_components?.find(c => c.types.includes('postal_code'))

			this.companyCountry = this.countries.find(c => c.id === country?.short_name) || {
				name: null,
				id: null
			}
			this.companyCity = city
			this.companyPostalCode = postalCode ? postalCode.short_name : null
		}
	}
}
</script>

<style module lang="scss">

.tab-wrapper {
  margin-top: $gutter * 2;
}
</style>


